export var GuidedWalkthroughTaskStatus;
(function (GuidedWalkthroughTaskStatus) {
    GuidedWalkthroughTaskStatus["Todo"] = "todo";
    GuidedWalkthroughTaskStatus["Done"] = "done";
    GuidedWalkthroughTaskStatus["Locked"] = "locked";
})(GuidedWalkthroughTaskStatus || (GuidedWalkthroughTaskStatus = {}));
export var GuidedWalkthroughTaskId;
(function (GuidedWalkthroughTaskId) {
    GuidedWalkthroughTaskId["SendData"] = "send-data";
    GuidedWalkthroughTaskId["InviteTeamMember"] = "invite-team-member";
    GuidedWalkthroughTaskId["CreateAlert"] = "create-alert";
    GuidedWalkthroughTaskId["ManageData"] = "manage-data";
    GuidedWalkthroughTaskId["SetLandingPage"] = "set-landing-page";
    GuidedWalkthroughTaskId["SearchInExplore"] = "search-in-explore";
    GuidedWalkthroughTaskId["SaveSearchInExplore"] = "save-search-in-explore";
    GuidedWalkthroughTaskId["GroupByInExplore"] = "group-by-in-explore";
})(GuidedWalkthroughTaskId || (GuidedWalkthroughTaskId = {}));
export class GuidedWalkthroughActionSection {
    callback;
    text;
    learnMoreUrl;
}
export class GuidedWalkthroughTask {
    id;
    userRoles;
    entityLevel;
    title;
    completeEventName;
    description;
    actionSection;
    hint;
    imageUrl;
}
//# sourceMappingURL=guided-walkthrough.js.map